import { useEffect, useState } from "react"

interface Props {
  embedUrl: string
  isShown?: boolean
  thumbImageUrl?: string
}

export default function FacebookVideo(props: Props) {
  const { embedUrl, isShown, thumbImageUrl } = props

  const [localActive, setLocalActive] = useState(false)

  useEffect(() => {
    if (!isShown) setLocalActive(false)
  }, [isShown])

  const isActive = !!isShown && localActive
  const aspectPadding = `${(16 / 9) * 100}%` // 약 177.78%s

  if (!isActive) {
    return (
      <button
        type="button"
        className="flex relative justify-center w-4/5 bg-black group"
        style={{ paddingTop: aspectPadding }}
        onClick={() => setLocalActive(true)}
      >
        {thumbImageUrl ? (
          <>
            <img
              src={thumbImageUrl}
              alt="Facebook Thumbnail"
              className="object-contain absolute inset-0 w-full h-full transition-opacity group-hover:opacity-80"
            />
            <span
              className="absolute top-1/2 left-1/2 z-10 p-4 text-white rounded-full bg-black/60"
              style={{ transform: "translate(-50%, -50%)" }}
            >
              <svg
                width="48"
                height="48"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </span>
          </>
        ) : (
          <div className="flex z-10 justify-center items-center w-full h-full text-center text-white">
            <p>Loading video...</p>
          </div>
        )}
      </button>
    )
  }

  return (
    <div className="relative w-4/5" style={{ paddingTop: aspectPadding }}>
      <iframe
        src={embedUrl}
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        className="absolute top-0 left-0 w-full h-full border-none pointer-events-auto"
        allowFullScreen
        title="Facebook Video"
      ></iframe>
    </div>
  )
}
